import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../login/services/auth-service.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  public usuario;
  public usuarioForm: FormGroup;
  min: Date = new Date(1900, 0, 1);
  max: Date = new Date(2007, 0, 1);
 public fechaNacimiento;
public id;
  constructor(private auth: AuthServiceService, private fb: FormBuilder, private toastr:ToastrService, private router:Router) { }

  ngOnInit(): void {
    this.id = this.auth.getUser().id;
    this.initForm();
    this.obtenerUsuario();

  }

  initForm() {
    this.usuarioForm = this.fb.group({
      
      nombre: [],
      apellidoPaterno: [],
      apellidoMaterno: [],
      permisos:[]
    })


  }

  obtenerUsuario(){
    this.auth.getUsuarioControl(this.id).subscribe(result=>{
      this.usuarioForm.patchValue({
      
        nombre: result.nombre,
        apellidoPaterno: result.apellidoPaterno,
        apellidoMaterno: result.apellidoMaterno,
        permisos:this.auth.getPermissions()
      })
    })
  }

  regresar(){
    this.router.navigateByUrl('/pages/panel-usuario')
  }
	actualizarUsuario() {
    //console.log(this.usuarioForm.value)
		this.auth.updateUsuario(this.id, this.usuarioForm.value).subscribe({
		next: success => {

				this.toastr.success('Usuario actualizado correctamente', 'Operación Exitosa');
				this.router.navigateByUrl('/pages/panel-usuario');
			
		},
		error: err => {
      //console.log(err)
      this.toastr.error('Ocurrio un error al actualizar lo datos');
		}
		});
	}

}
